import React from 'react'
import * as R from 'ramda'
import {
  compose,
  withStateHandlers,
  branch,
  withPropsOnChange,
} from 'recompose'

import isEmpty from 'lodash/isEmpty'

import { IssueLinkCollapseWidget } from './IssueLinkCollapseWidget'
import { ISSUE_LINK_SYSTEM_TYPE } from './constants'
import { withEsuzIssueOnView } from './withEsuzIssue'
import { withToirIssueOnView } from './withToirIssue'

const formEnhancer = compose(
  branch(
    ({ data: { esuz, esuzSystemType } = {} }) => esuz && esuzSystemType,
    compose(
      withPropsOnChange([`data`], ({ data }) => ({
        issueLinkSystemType: R.prop(`esuzSystemType`, data),
      })),
      withStateHandlers({
        issueLink: {},
      }, {
        setIssueLinkData: () => (issueLink) => ({ issueLink }),
      }),
      branch(
        ({ data: { esuzSystemType } = {} }) => esuzSystemType === ISSUE_LINK_SYSTEM_TYPE.ahp,
        withEsuzIssueOnView,
      ),
      branch(
        ({ data: { esuzSystemType } = {} }) => esuzSystemType === ISSUE_LINK_SYSTEM_TYPE.toir,
        withToirIssueOnView,
      ),
    ),
  ),
)

const IssueLinkViewWidget = ({
  issueLink,
  issueLinkSystemType,
}) => {
  if (!isEmpty(issueLink)) {
    return (
      <IssueLinkCollapseWidget issueLinkSystemType={issueLinkSystemType} issueLink={issueLink} />
    )
  }
  return null
}

export default formEnhancer(IssueLinkViewWidget)
